/* 1/11 2026: lagt-i-kurven-stripa er fjernet. Den ventet på .banner--success, som Prestige bare lager
   når kurvtypen er «message»; vi bruker skuff («drawer»), så stripa vistes aldri, men overvåket hele siden. */

/* Fraktbar-progresjon: leser threshold/total-price fra Prestige-elementet
   og setter --ts-progress for den stille streken. */
(function () {
  function oppdater(el) {
    var t = parseInt(el.getAttribute('threshold'), 10);
    var p = parseInt(el.getAttribute('total-price'), 10);
    if (t > 0 && p >= 0) el.style.setProperty('--ts-progress', Math.min(100, Math.round(p / t * 100)) + '%');
  }
  function koble(el) {
    oppdater(el);
    new MutationObserver(function () { oppdater(el); })
      .observe(el, { attributes: true, attributeFilter: ['total-price', 'threshold'] });
  }
  document.querySelectorAll('free-shipping-bar').forEach(koble);
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      [].forEach.call(m.addedNodes, function (n) {
        if (n.nodeType !== 1) return;
        if (n.tagName === 'FREE-SHIPPING-BAR') koble(n);
        else if (n.querySelectorAll) n.querySelectorAll('free-shipping-bar').forEach(koble);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
